import {Injectable} from '@angular/core';
import {MatDialog, MatDialogConfig, MatDialogRef} from '@angular/material/dialog';


import {ModalComponent} from '../shared/components/modal/modal.component';
import {BehaviorSubject} from 'rxjs';
import {
  StandardNotificationComponent
} from '../features/webbiat-notification-creator/standard-notification/standard-notification.component';

@Injectable({
  providedIn: 'root'
})
export class ModalService {

  dialogRef: MatDialogRef<any> | undefined;
  confirmButtonDisabled$: BehaviorSubject<boolean> = new BehaviorSubject(true);
  loading$: BehaviorSubject<boolean> = new BehaviorSubject(false);
  private selectedNotifType: string = "";
  private parentName: string = "";
  private inputValue: string = '';
  constructor(private _modalService: MatDialog) { }

  toggleModal(
    title: string,
    textContent: string,
    cancelLabel: string,
    submitLabel: string,
    modalWidth: string,
    dynamicComponent: any = null,
    confirm: (() => void) | null = null,
    showCancelButton: boolean = true,
    btnIcon: string = '',
    props: any = null,
    isReversed: boolean = false,
    autoClose: boolean = true
  ) {

    const dialogConfig = new MatDialogConfig();

    dialogConfig.disableClose = false;
    dialogConfig.autoFocus = false;
    dialogConfig.width = modalWidth;
    dialogConfig.backdropClass = 'shared-modal-backdrop';

    const modalRef = this._modalService.open(ModalComponent, dialogConfig);
    this.setLoading(false);

    modalRef.componentInstance.title = title;
    modalRef.componentInstance.textContent = textContent;
    modalRef.componentInstance.cancelLabel = cancelLabel;
    modalRef.componentInstance.submitLabel = submitLabel;
    modalRef.componentInstance.isReversed = isReversed;
    modalRef.componentInstance.showCancelButton = showCancelButton;
    modalRef.componentInstance.btnIcon = btnIcon;
    modalRef.componentInstance.componentProps = props;

    if (dynamicComponent) {
      modalRef.componentInstance.dynamicComponent = true;
      const componentRef = modalRef.componentInstance.modalBody.createComponent(dynamicComponent);
      const componentInstance: any = componentRef.instance;
      Object.assign(componentInstance, props);
    }

    modalRef.componentInstance.modalEvent.subscribe((confirmClicked: boolean) => {
      if (confirmClicked && confirm) {
        if (dynamicComponent === StandardNotificationComponent) {
          confirm();
      } else {
          confirm();
          if (autoClose) {
            modalRef.close();
          }
      }
      }
    })

    modalRef.componentInstance.modalDismissEvent.subscribe((cancelBtnClicked: boolean) => {
      if (cancelBtnClicked) {
        modalRef.close();
      }
    })

    this.dialogRef = modalRef;
  }

  getConfirmButtonDisabled() {
    return this.confirmButtonDisabled$.asObservable();
  }

  setConfirmButtonDisabled(confirmButtonDisabled: boolean) {
    this.confirmButtonDisabled$.next(confirmButtonDisabled);
  }

  setLoading(loading: boolean) {
    this.loading$.next(loading);
  }

  getLoading() {
    return this.loading$.asObservable();
  }

  closeModal() {
    if (this.dialogRef) {
      this.dialogRef.close();
    }
  }

  setSelectedNotifType(value: string): void {
    this.selectedNotifType = value;
  }

  getSelectedNotifType(): string {
    return this.selectedNotifType;
  }

  setParentName(value: string): void {
    this.parentName = value;
  }

  getParentName(): string {
    return this.parentName;
  }

  setDialogRef(dialogRef: MatDialogRef<any>) {
    this.dialogRef = dialogRef;
  }

  updateModalSize(width: string, height?: string) {
    if (this.dialogRef) {
      this.dialogRef.updateSize(width, height);
    }
  }

  setinputValue(value: string) {
    this.inputValue = value;
  }

  getInputValue(): string {
    return this.inputValue;
  }
}
